import React from "react";
import { useSelector } from "react-redux";
import ProfileCard from "../../common/profileCard";
import RecruiterSidebar from "../../common/recruiterSidebar";
import SettingsLinks from "../settingsLinks/settingsLinks";

const RecruiterDocuments = () => {
    const user = useSelector((state: any) => state.auth.user);
    const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

    const signedAgreement = user?.recruiterOnboarding?.signedAgreement;
    const certificate = user?.recruiterOnboarding?.certificate;

    const renderDocumentCard = (
        label: string,
        doc: any,
        iconClass: string,
        colorClass: string,
        emptyText: string,
    ) => (
        <div className="col-md-6 mb-4">
            <div className="card h-100 border">
                <div className="card-body d-flex flex-column">
                    <div className="d-flex align-items-center mb-3">
                        <span className={`icon-box ${colorClass} me-3 flex-shrink-0`}>
                            <i className={`${iconClass} fs-20`} />
                        </span>
                        <h6 className="mb-0 fw-semibold">{label}</h6>
                    </div>
                    {doc ? (
                        <>
                            <p className="text-muted fs-13 mb-3 text-truncate">
                                {doc.filename || label}
                            </p>
                            <div className="mt-auto">
                                <a
                                    href={`${baseUrl}${doc.url}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-primary btn-sm rounded-pill"
                                >
                                    <i className="isax isax-document-download me-2" />
                                    Download
                                </a>
                            </div>
                        </>
                    ) : (
                        <p className="text-muted fs-13 mb-0 mt-auto">{emptyText}</p>
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <>
            <div className="content">
                <div className="container">
                    <ProfileCard />
                    <div className="row">
                        <RecruiterSidebar />
                        <div className="col-lg-9">
                            <div className="mb-3">
                                <h5>Settings</h5>
                            </div>
                            <SettingsLinks />
                            <div className="card">
                                <div className="card-body">
                                    <div className="edit-profile-info mb-4">
                                        <h5 className="mb-1">Onboarding Documents</h5>
                                        <p className="text-muted mb-0">
                                            Your partnership documents issued during the onboarding process.
                                        </p>
                                    </div>
                                    <div className="row">
                                        {renderDocumentCard(
                                            "Signed Agreement",
                                            signedAgreement,
                                            "isax isax-document-text",
                                            "bg-info-transparent",
                                            "Not yet uploaded. Please sign and upload the partnership agreement from your dashboard.",
                                        )}
                                        {renderDocumentCard(
                                            "Certificate of Representation",
                                            certificate,
                                            "isax isax-award",
                                            "bg-success-transparent",
                                            "Not yet issued. Your certificate will appear here once your account is fully activated.",
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RecruiterDocuments;
